import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customSubscriptionIntervalFormatter',
  // standalone: false,
})
export class IntervalFormatterPipe implements PipeTransform {
  transform(value: string): string {
    if (!value?.startsWith('P')) {
      return 'Invalid Interval';
    }

    const durationRegex = /P(?:(\d+)D)?(?:(\d+)W)?(?:(\d+)M)?(?:(\d+)Y)?/;
    const matches = value.match(durationRegex);

    if (!matches) {
      return 'Invalid Interval';
    }

    const days = matches[1] ? parseInt(matches[1], 10) : 0;
    const weeks = matches[2] ? parseInt(matches[2], 10) : 0;
    const months = matches[3] ? parseInt(matches[3], 10) : 0;
    const years = matches[4] ? parseInt(matches[4], 10) : 0;

    let result = '';

    if (years) {
      result += `${years} year${years > 1 ? 's' : ''} `;
    }
    if (months) {
      result += `${months} month${months > 1 ? 's' : ''} `;
    }
    if (weeks) {
      result += `${weeks} week${weeks > 1 ? 's' : ''} `;
    }
    if (days) {
      result += `${days} day${days > 1 ? 's' : ''} `;
    }

    return result.trim() || 'Unknown Interval';
  }
}
